module.exports = __webpack_public_path__ + "static/media/FF184D78-4D6F-4B53-A1EC-77BA9E7B0034.03d53fc2.JPG";